import { useState } from "react";
import {
  Box,
  Button,
  ButtonBase,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import type { Schema } from "@bw/shared/types/generated";

export function FacilityPhotos({
  photos,
}: {
  photos: Schema["FacilityPhoto"][];
}) {
  const [selected, setSelected] = useState<number | null>(null);
  if (!photos.length) return null;
  const current = selected === null ? null : photos[selected];
  return (
    <>
      <Box
        component="section"
        aria-label="Facility photos"
        sx={{ display: "flex", gap: 1, overflowX: "auto" }}
      >
        {photos.map((photo, index) => (
          <ButtonBase
            key={photo.url}
            onClick={() => setSelected(index)}
            aria-label={`View photo: ${photo.alt_text}`}
            sx={{ flex: "0 0 auto", borderRadius: 2, overflow: "hidden" }}
          >
            <Box
              component="img"
              src={photo.url}
              alt={photo.alt_text}
              loading={index ? "lazy" : "eager"}
              sx={{
                width: { xs: 260, md: 360 },
                height: { xs: 180, md: 240 },
                objectFit: "cover",
              }}
            />
          </ButtonBase>
        ))}
      </Box>
      <Dialog
        open={Boolean(current)}
        onClose={() => setSelected(null)}
        maxWidth="lg"
      >
        <DialogTitle>Facility photo viewer</DialogTitle>
        <DialogContent>
          {current ? (
            <Box
              component="img"
              src={current.url}
              alt={current.alt_text}
              sx={{ maxWidth: "100%", maxHeight: "75vh", objectFit: "contain" }}
            />
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            disabled={selected === null || selected <= 0}
            onClick={() =>
              setSelected((value) => (value === null ? 0 : value - 1))
            }
          >
            Previous
          </Button>
          <Button
            size="small"
            disabled={selected === null || selected >= photos.length - 1}
            onClick={() =>
              setSelected((value) => (value === null ? 0 : value + 1))
            }
          >
            Next
          </Button>
          <Button size="small" onClick={() => setSelected(null)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
